<template lang="pug">
  .downdraft-grid
    .downdraft-grid__block(v-for="option in active.options")
      button.dd-btn.downdraft-grid__content(:style="`background-image:url(${ option.image })`", @click="selectOption(option)", :class="{'is-selected' : isSelected(option)}")
        p.downdraft-grid__title {{ option.name }}
      .downdraft-grid__dropout(v-if="visibleResultId === option.id")
        .downdraft-grid__options(v-for="(item, index) in results")
          p.downdraft-grid__options-title Option {{ index + 1 }}
          .downdraft-grid__item
            .downdraft-grid__item-image
              img(:src="item.image")
              p.downdraft-grid__item-caption {{ item.caption }}
            .downdraft-grid__item-content
              p {{ labels.intro }}
              ul.downdraft-grid__item-list
                li(v-for="el in item.list") {{ el }}
              p {{ labels.review }}
              .downdraft-grid__share
                p {{ labels.share }}
              .downdraft-grid__actions
                a(href="#", @click.prevent="print()")
                  img(src="/img/icons/print.svg")
                a(:href="getEmailString(item)")
                  img(src="/img/icons/email.svg")
</template>

<script>
import { mapActions, mapGetters } from 'vuex'

export default {
  name: 'Grid',
  props: ['session', 'config', 'active', 'labels'],
  data: function () {
    return {}
  },
  computed: {
    visibleResultId() {
      return this.$store.state.visibleResultId
    },
    results() {
      return this.$store.state.results
    },
    emailSelections() {
      let str = ''
      this.config.forEach((el, index) => {
        if (!!this.session[el.title] && index + 1 !== this.config[this.config.length - 1].step) {
          let obj = el.options.find((opt) => {
            return opt.id === this.session[el.title]
          })
          str += `${el.title}: ${obj.name}%0D%0A`
        }
      })
      return str
    },
    queryString() {
      let str = ''
      if (this.session.step === this.config.length) {
        this.config.forEach((el, index) => {
          let _obj = el.options.find((opt) => {
            return opt.id === this.session[el.title]
          })
          str += `/${_obj.id}`
        })
      }
      return str
    },
  },
  methods: {
    ...mapActions(['fetchResults']),
    print() {
      window.print()
    },
    getEmailString(item) {
      const subject = this.labels.emailSubject
      const emailBody = `${this.labels.emailBody[0]}: ${item.caption}. ${this.labels.emailBody[1]}:%0D%0A%0D%0A${
        this.emailSelections
      }%0D%0A${this.labels.intro}%0D%0A%0D%0A• ${item.list.join('%0D%0A • ')}%0D%0A%0D%0A${this.labels.review}`
      return `mailto:?subject=${subject}&body=${emailBody}`
    },
    email(option, item) {
      let email = ''
      let subject = this.labels.emailSubject
      let emailBody = `
				${this.labels.emailBody[0]}: ${item.caption}. ${this.labels.emailBody[1]}:
				%0D%0A
				%0D%0A
				${this.emailSelections}
				%0D%0A
				${this.labels.intro}
				%0D%0A
				%0D%0A
				• ${item.list.join('%0D%0A • ')}
				%0D%0A
				%0D%0A
				${this.labels.review}
			`
      document.location = 'mailto:' + email + '?subject=' + subject + '&body=' + emailBody
    },
    selectOption(val) {
      this.$store.commit('setStepOption', { step: this.active.title, value: val.id })
      this.$emit('error', false)
      if (this.session.step === this.config.length) {
        // console.log('new result call')
        this.$store.commit('write_state', { key: 'visibleResultId', value: val.id })
        // let fetchEP = window.location.hostname === 'localhost' ? this.$root.results : `${this.$root.api}get/installationresults${this.queryString}`
        return this.fetchResults(`${this.$root.api}get/installationresults${this.queryString}`).then(() => {
          return true
        })
      }
    },
    isSelected(val) {
      return this.session[this.active.title] === val.id
    },
  },
}
</script>

<style lang="scss">
.downdraft-grid {
  display: grid;
  grid-auto-rows: auto;
  gap: 2rem 1rem;
  $i: 1;
  $order: 1;
  @media screen and (min-width: 1025px) {
    grid-template-columns: 1fr 1fr 1fr 1fr;
    @for $i from 1 through 12 {
      @if ($i - 1) %4 == 0 {
        $order: $order + 2;
      }
      .downdraft-grid__block:nth-child(#{$i}) {
        .downdraft-grid__content {
          order: $order;
        }
        .downdraft-grid__dropout {
          order: $order + 1;
        }
      }
    }
  }
  @media screen and (max-width: 1024px) {
    grid-template-columns: 1fr 1fr 1fr;
    @for $i from 1 through 12 {
      @if ($i - 1) %3 == 0 {
        $order: $order + 2;
      }
      .downdraft-grid__block:nth-child(#{$i}) {
        .downdraft-grid__content {
          order: $order;
        }
        .downdraft-grid__dropout {
          order: $order + 1;
        }
      }
    }
  }
  @media screen and (max-width: 768px) {
    grid-template-columns: 1fr 1fr;
    @for $i from 1 through 12 {
      @if ($i - 1) %2 == 0 {
        $order: $order + 2;
      }
      .downdraft-grid__block:nth-child(#{$i}) {
        .downdraft-grid__content {
          order: $order;
        }
        .downdraft-grid__dropout {
          order: $order + 1;
        }
      }
    }
  }
  @media screen and (max-width: 480px) {
    grid-template-columns: 1fr;
    @for $i from 1 through 12 {
      @if ($i - 1) %1 == 0 {
        $order: $order + 2;
      }
      .downdraft-grid__block:nth-child(#{$i}) {
        .downdraft-grid__content {
          order: $order;
        }
        .downdraft-grid__dropout {
          order: $order + 1;
        }
      }
    }
  }
}

.downdraft-grid__block {
  display: contents;
}

.downdraft-grid__content {
  grid-area: span 1 / span 1;
  position: relative;
  z-index: 0;
  display: block;
  height: 10rem;
  background-size: cover;
  background-position: 50% 50%;
  border: 1px solid #cfcfcf;
  cursor: pointer;
  overflow: visible;
  &.is-selected {
    &:after {
      position: absolute;
      content: '';
      left: 0;
      right: 0;
      top: 0;
      bottom: 0;
      border: 4px solid #376074;
    }
  }
  &:hover {
    background-size: cover !important;
    background-position: 50% 50% !important;
  }
}

.downdraft-grid__dropout {
  grid-row: span 1;
  grid-column: 1 / -1;
  border: 4px solid #376074;
}

.downdraft-grid__title {
  z-index: 1;
  position: absolute;
  bottom: -1rem;
  right: -1px;
  left: 1rem;
  background: rgba(0, 0, 0, 0.75);
  color: #ffffff;
  margin: 0 auto 0 0;
  padding: 0.5rem 1rem;
  font-weight: 300;
}

.downdraft-grid__options {
  padding: 2rem 1rem 1rem 1rem;
  &-title {
    font-size: 1.5rem;
    font-weight: bold;
  }
}

.downdraft-grid__item {
  display: flex;
  @media screen and (max-width: 1024px) {
    flex-direction: column;
  }
  &-image {
    flex: 0 0 300px;
    @media screen and (max-width: 1024px) {
      flex: 1;
      margin: 0 auto;
      padding-bottom: 1rem;
      img {
        width: 100%;
        background-size: cover;
        display: block;
        margin: 0 auto;
      }
      p {
        text-align: center;
      }
    }
  }
  &-content {
    padding-left: 2rem;
    flex: 0 0 1;
    @media screen and (max-width: 1024px) {
      padding-left: 0;
      .downdraft-grid__item-list {
        padding-left: 1rem;
      }
    }
  }
  &-caption {
    font-weight: bold;
    margin: 0;
    padding-top: 1rem;
  }
  &-list li {
    padding-bottom: 0.5rem;
  }
}

.downdraft-grid__share {
  border-top: 2px solid #000000;
  padding-top: 1rem;
  p {
    margin-bottom: 0.5rem;
    font-weight: bold;
  }
}

.downdraft-grid__actions {
  img {
    transition: 0.25s ease;
    width: 2rem;
    margin-right: 1rem;
    cursor: pointer;
    opacity: 0.7;
    &:hover {
      opacity: 1;
    }
  }
}

.site-modals {
  display: none !important;
}
@media print {
  header,
  footer,
  .downdraft__copy,
  .downdraft-trail,
  .downdraft__prompt,
  .downdraft-grid__content,
  .downdraft-actions,
  .downdraft-grid__share,
  .downdraft-grid__actions,
  .downdraft__error,
  .site-modals {
    display: none !important;
  }
  .downdraft__heading {
    text-align: center;
    padding-top: 1rem;
    margin-bottom: 0 !important;
  }
  .downdraft-grid__dropout {
    border: 0 !important;
  }
}
</style>
